import { CONVERSION_FACTORS, MATERIAL_CONSTANTS } from '../constants/calculator_constants';

export type StressForceResult = {
  kpsi: number;
  gpa: number;
  grams: number;
};

export function computeStressForceFromStrain(
  strainPercent: number,
  diameterMicrons: number,
  youngsModulus = MATERIAL_CONSTANTS.E0_MPA
): StressForceResult {
  const strain = strainPercent / 100;
  var stressGPa = strain * youngsModulus;
  var stressKpsi = stressGPa / CONVERSION_FACTORS.KSI_TO_GPA;
  
  // Calculate grams
  const radiusMeters = (diameterMicrons / 2) * 1e-6;
  const areaMeters2 = Math.PI * radiusMeters * radiusMeters;
  const stressPa = stressGPa * 1e9;
  const forceNewtons = stressPa * areaMeters2;
  const grams = ((forceNewtons * 1000) / CONVERSION_FACTORS.GRAVITY)/1000;

  stressKpsi = stressKpsi/1000;
  stressGPa = stressGPa/1000;




  return {
    kpsi: stressKpsi,
    grams: grams,
    gpa: stressGPa,
  };
}

export default computeStressForceFromStrain;